import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	viewBox: "0 0 16 16",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m8 0c.55228475 0 1 .44771525 1 1v6h6c.5128358 0 .9355072.38604019.9932723.88337887l.0067277.11662113c0 .55228475-.4477153 1-1 1h-6v6c0 .5128358-.38604019.9355072-.88337887.9932723l-.11662113.0067277c-.55228475 0-1-.4477153-1-1v-6h-6c-.51283584 0-.93550716-.38604019-.99327227-.88337887l-.00672773-.11662113c0-.55228475.44771525-1 1-1h6v-6c0-.51283584.38604019-.93550716.88337887-.99327227z" })
});
export default SvgPlus;
